import {z} from 'zod';

import {DMS_OAUTH_FLOW_COOKIE_NAME} from './DMS_OAUTH_FLOW_COOKIE_NAME';

const OAUTH_FLOW_SCHEMA = z.object({verifier: z.string().min(1), state: z.string().min(1)});

export const readOAuthFlowCookie = () => {
  const prefix = `${DMS_OAUTH_FLOW_COOKIE_NAME}=`;
  return document.cookie
    .split(';')
    .map((value) => value.trim())
    .filter((value) => value.startsWith(prefix))
    .flatMap((cookie) => {
      try {
        const value: unknown = JSON.parse(decodeURIComponent(cookie.slice(prefix.length)));
        const result = OAUTH_FLOW_SCHEMA.safeParse(value);
        return result.success ? [result.data] : [];
      } catch {
        return [];
      }
    });
};
